import { ref, onMounted, onUnmounted } from "vue";
import { generateContainerId, onWrapperMount, onWrapperUnmount, renderRoot } from "./utils.js";
const createMfWrapper = async (args) => {
  const setup = () => {
    const isLoaded = ref();
    const onUnmount = ref();
    const containerRef = ref();
    const containerId = generateContainerId(args.mf.id);
    let watchHandles = [];
    onMounted(
      () => onWrapperMount(
        args,
        watchHandles,
        containerRef,
        onUnmount,
        isLoaded,
        containerId
      )
    );
    onUnmounted(
      () => onWrapperUnmount(
        args.mf.id,
        watchHandles,
        containerId,
        onUnmount
      )
    );
    return () => renderRoot(isLoaded, containerId, args.mf.id, containerRef);
  };
  return {
    setup
  };
};
export {
  createMfWrapper
};
